module.exports = __webpack_public_path__ + "img/kr-product-agency-card2-img4.88bdf63.png";